// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/8ee6ca4fb52d2fed93f6.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7db3568f085a27902175","140":"082e19ff68e9b266948a","141":"38e34a1ed267b98cc6b6"}[chunkId] + ".chunk.js";
};